import { useCallback, useEffect, useState } from "react"

function storageKey(formId: string): string {
  return `formPopupSubmitted:${formId || "default"}`
}

function hasSubmitted(formId: string): boolean {
  if (typeof window === "undefined" || !formId) return false
  return localStorage.getItem(storageKey(formId)) === "true"
}

export function useFormPopupVisibility(formId: string) {
  const [showModal, setShowModal] = useState(() =>
    formId ? !hasSubmitted(formId) : false
  )

  useEffect(() => {
    if (!formId) return
    setShowModal(!hasSubmitted(formId))
  }, [formId])

  const markSubmitted = useCallback(() => {
    if (!formId) return
    localStorage.setItem(storageKey(formId), "true")
  }, [formId])

  const dismiss = useCallback(() => {
    setShowModal(false)
  }, [])

  return { showModal, markSubmitted, dismiss }
}
